<div class="page" *ngIf="!loading; else loadingTpl">
  <h1>Map Images</h1>
  <p class="intro">Upload staff image assets for the in-game map placement menu. These uploads appear under Staff Images.</p>

  <div class="upload-card">
    <mat-card>
      <mat-card-title>Upload image</mat-card-title>
      <mat-card-content>
        <input class="file-input" type="file" multiple accept="image/png,image/jpeg" (change)="chooseFile($event)">
        <p class="filename" *ngIf="selectedFiles.length">
          {{ selectedFiles.length }} image{{ selectedFiles.length === 1 ? '' : 's' }} selected
        </p>
        <button mat-raised-button color="primary" [disabled]="!selectedFiles.length || uploading" (click)="upload()">
          {{ uploading ? 'Uploading...' : 'Upload image' + (selectedFiles.length === 1 ? '' : 's') }}
        </button>
      </mat-card-content>
    </mat-card>
  </div>

  <h2>Uploaded images</h2>
  <div class="gallery" *ngIf="images.length; else emptyTpl">
    <mat-card class="image-card" *ngFor="let image of images">
      <img [src]="imageUrl(image)" [alt]="image.name">
      <mat-card-content><b>{{ image.name }}</b><small>Asset: {{ image.asset }}</small></mat-card-content>
      <mat-card-actions><button mat-button color="warn" (click)="$event.stopPropagation(); remove(image)">Delete</button></mat-card-actions>
    </mat-card>
  </div>
</div>

<ng-template #emptyTpl><p>No uploaded map images yet.</p></ng-template>
<ng-template #loadingTpl><div class="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner><p>Loading map images...</p></div></ng-template>
